"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@mui/material/utils");
var Icon = function (props) { return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "m0 16.77 11.578 6.562v-5.625L0 12.551Zm24-4.22-11.578 5.157v5.625L24 16.793Zm-2.664.477 1.816-.804-3.988-1.512-.367 1c.726.32 1.594.781 2.539 1.316ZM16.75.668l-.754 2.121a1.356 1.356 0 0 0 1.098 1.672l-1.258 3.504c-1.02-.426-1.934-.133-2.48.46l-1.38-.527L.849 12.223l1.812.789c2.98-1.774 6.504-3 9.88-2.805l-.49 1.313c-1.28.039-2.378.359-3.34.89 3.356-.543 6.849.356 9.43 1.684-.062-.305-.234-.582-.519-.856l.914-2.59c.277-.738.059-2.136-1.652-2.39l1.262-3.496c1.18.297 1.886-.473 2.05-.985l.692-1.96Zm2.355 2.844c-.035.14-.285.258-.484.168l-1.234-.344c-.239-.098-.332-.242-.254-.45l.289-.82 2.015.563Zm0 0", style: {
            stroke: 'none',
            fillRule: 'nonzero',
            fill: '#000',
            fillOpacity: 1,
        } }))); };
var SvgSandbox = (0, utils_1.createSvgIcon)(React.createElement(Icon, null), 'SvgSandbox');
exports.default = SvgSandbox;
